import { SessionFilterStorage } from './session-filter-storage';
import type { FilterStorageId } from './types';

export class QuickFilterStorage extends SessionFilterStorage {
  /**
   * @private
   * @return {Object} - resource and entry ids
   */
  getSessionStorageId({
    featureName,
    entityName,
  }: { featureName?: string; entityName?: string }): FilterStorageId {
    // Resource id is for defining resource
    // Entry id is for defining each entry under the same resource
    return {
      resourceId: `quick-filter-storage-campaignwebui-${featureName}`,
      entryId: `${entityName}/QuickFilter`,
    };
  }

  /**
   * Save quick filter key and query to session
   * @param {string} key - Filter key
   * @param {Object} value - Filter query object
   * @return {undefined}
   */
  save(key: string, value: any) {
    this.storage.create({
      id: this.entryId,
      filter: {
        key,
        value,
      },
    });
  }

  /**
   * Get quick filter object
   * @return {Object} - Quick filter object that contains
   * key and query
   */
  get() {
    // TODO: based on the scenario entity, decide if we want to also
    // get the waterfall filter.
    return this.storage.find(this.entryId)
      .catch((): null => null);
  }
}
